import React from 'react';
import PropTypes from 'prop-types';

const ArpActionLink = ({
  href,
  text,
  icon = 'chevron_right',
  className,
  backgroundColor = 'primary',
}) => {
  return (
    <div
      className={`vads-u-display--flex vads-u-align-items--center ${
        className || ''
      }`}
    >
      <va-icon
        class={`circle vads-u-background-color--${backgroundColor} vads-u-color--white vads-u-margin-right--1`}
        icon={icon}
        size="2"
      />
      <va-link
        class="vads-u-font-size--md vads-u-font-weight--bold"
        href={href}
        text={text}
      />
    </div>
  );
};

ArpActionLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
};

export default ArpActionLink;
